var version = '6.5.2';

module.exports = version;
